import { FaTimes } from "react-icons/fa";
import { IoIosArrowDown } from "react-icons/io";
import styled from "styled-components";

export const FilterCriteriaCard = styled.div`
  display: flex;
  flex-direction: column;
  background: ${({ theme }) => theme.colors.white};
  box-shadow: 2px 2px 10px 0px rgba(0, 0, 0, 0.25);
  border-radius: 8px;
  padding: 1.45rem;
  gap: 1rem;
  max-height: 51px;
  overflow: hidden;
  transition: max-height 0.5s cubic-bezier(0, 1, 0, 1);

  &.full {
    max-height: 100%;
    transition: max-height 1s ease-in-out;
  }
`;

export const FilterCriteriaHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const FilterContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 0.15rem 0 !important;
  border: 1.5px solid ${({ theme }) => theme.colors.menuBlueLight};
  border-radius: 100px;
  padding: 0.8rem 1rem;
  gap: 1.5rem;
  box-shadow: 2px 2px 5px 0px rgba(0, 0, 0, 0.25);
`;

export const ClearFiltersButton = styled(FilterContainer as any)`
  text-transform: uppercase;
  cursor: pointer;
`;

export const ClickableCross = styled(FaTimes)`
  cursor: pointer;
  font-size: 1.5rem;
  border: 2px solid ${({ theme }) => theme.colors.menuBlueLight};
  border-radius: 50%;
  padding: 0.2rem;
`;

export const ClearAllCross = styled(ClickableCross as any)``;

export const ClearAllText = styled.span`
  font-weight: 600;
  font-style: normal;
  line-height: normal;
`;

export const Icon = styled.i`
  margin-right: 5px;
`;

export const CollapseArrowDown = styled(IoIosArrowDown)`
  color: ${({ theme }) => theme.colors.menuBlueLight};
  font-size: 3rem;
  align-self: flex-start;
  stroke-width: 4rem;
  cursor: pointer;
`;

export const CollapseArrowUp = styled(CollapseArrowDown as any)`
  transform: rotate(180deg);
`;

export const FilterActionsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 3vw;
`;

export const FilterExportIconsContainer = styled(FilterActionsContainer as any)`
  gap: 1.5vw;
`;

export const FiltersContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 1.5rem;
  width: 100%;
  overflow: hidden;
`;
